module.exports = __webpack_public_path__ + "static/media/Список_участников_стендовой_сессии_new.509dd7c3.pdf";